module.exports = __webpack_public_path__ + "img/limit-card-right-image.de4917d9.png";